import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import UomService from "../../../services/UomService";
import Breadcrumb from "../../../components/Breadcrumb";
import ListUom from "../Components/ListUom";
import MessageDialog from "../../../components/MessageDialog";

export default function ViewUom() {
  const [uoms, setUoms] = useState([]);
  const [selected, setSelected] = useState(null); //  RADIO (single select)
  const [searchText, setSearchText] = useState(""); //  SEARCH
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(true);
  // const messageTimer = useRef(null);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();

  useEffect(() => {
    fetchUoms();
  }, [currentPage]);

  const fetchUoms = async () => {
    setLoading(true);
    try {
      const res = await UomService.getAll(currentPage, itemsPerPage);

      const data = res?.data || [];

      setUoms(data);
      setPageCount(res.totalPages || 0);
    } catch (error) {
      console.error(error);
      showMessage("Error loading UOMs.");
    } finally {
      setLoading(false);
    }
  };



  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  //  RADIO SELECT
  const handleSelect = (id) => {
    setSelected(id);
  };

  const handleAdd = () => {
    navigate("/cpnl/uom/add");
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };


  const handleModify = () => {
    if (!selected) {
      showMessage("Please select one UOM to modify.");
      return;
    }
    navigate(`/cpnl/uom/add/${selected}`);
  };

  const handleToggleStatus = async (uom) => {
    const newStatus =
      uom.status === "Active" || uom.status === 1 || uom.status === true
        ? "Inactive"
        : "Active";

    if (
      !window.confirm(
        `Are you sure do you want change status as ${newStatus}?`
      )
    )
      return;

    setLoading(true);
    try {
      await UomService.update(uom.id, { ...uom, status: newStatus });
      showMessage(`Updated status as ${newStatus} successfully!`, "success");
      fetchUoms();
    } catch (error) {
      console.error(error);
      showMessage("Error updating UOM status.");
    } finally {
      setLoading(false);
    }
  };

  //  FRONTEND SEARCH FILTER
  const filteredUoms = uoms.filter((uom) =>
    uom.uomCode?.toLowerCase().includes(searchText.toLowerCase())
  );



  return (
    <>
      <Breadcrumb pageTitle="UOMS" secondTitle="Masters" />

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center w-100 mb-3 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              ></button>
            </div>
          )} */}

          
            <MessageDialog
              message={message}
              type={msgType}
              setMessage={setMessage}
              setMsgType={setMsgType}
            />
          
          {/*  SEARCH + ADD / MODIFY */}
          <div className="mb-3 pb-2 border-bottom d-flex align-items-end gap-3">
            <div>
              <input
                type="text"
                className="form-control"
                placeholder="Search UOM Code"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>

            <div className="ms-auto d-flex gap-2">
              <button
                className="d-inline-flex btn btn-success"
                onClick={handleAdd}
                disabled={loading}
              >
                <i className="ti ti-plus me-1"></i> Add
              </button>

              <button
                className="d-inline-flex btn btn-warning"
                onClick={handleModify}
                disabled={loading}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            </div>
          </div>

          {/*  TABLE */}
          <ListUom
            loading={loading}
            filteredUoms={filteredUoms}
            selected={selected}
            handleSelect={handleSelect}
            handleToggleStatus={handleToggleStatus}
            pageCount={pageCount}
            handlePageClick={handlePageClick}
          />
        </div>
      </div>
    </>
  );
}
